export const HYPHEN = "‐";
export const LONG_EM_DASH = "—";
